import { useState } from 'react';
import { Link } from 'react-router-dom';
import requestManager from '../utils/requestManager.js';
import validateEmail from '../utils/validateEmail.js';

function Login() {

    const [logging, setLogging] = useState(false);
    const [user, setUser] = useState({});

    const handleChange = (e) => {
        setUser({...user, [e.currentTarget.id]: e.currentTarget.value});
    };

    const handleLogin = (e) => {
        e.preventDefault();

        setLogging(true);
        let url = '/Authentication/GetToken';
        let data = {
            password: user.password,
            limited: true
        }

        if (validateEmail(user.login)) {
            url = '/Authentication/GetTokenUPN';
            data.account = user.login;
        }
        else {
            if (user.login.indexOf('.') !== -1) {
                data.company = user.login.substr(0, user.login.indexOf('.'));
                data.username = user.login.substr((user.login.indexOf('.')+1));
            }
        }
        
        requestManager(url, 'POST', data,
            (res) => {
                setLogging(false);

                if (res.token) {
                    localStorage.setItem('silicom_token', res.token);
                    window.location.reload();
                }
            },
            {
                400: "L’utilisateur n’est pas valide",
                401: "Utilisateur ou mot de passe incorrect",
                403: "L’utilisateur n’est pas autorisé à utiliser l’API"
            }
        );
    }

    return (<div className="uk-container-login">        
        <div className="mc-widget" style={{padding: '35px'}}>           
            <form onSubmit={handleLogin}>
                <div className="uk-grid-login">
                    <div className="">
                        <label className="uk-form-label" htmlFor="login">Utilisateur</label>
                        <div className="uk-form-controls">
                            <input className="uk-input" id="login" type="text" value={user.login || ''} onChange={handleChange} required/>
                        </div>
                    </div>

                    <div className="">
                        <label className="uk-form-label" htmlFor="password">Mot de passe</label>
                        <div className="uk-form-controls">
                            <input className="uk-input" id="password" type="password" value={user.password || ''} onChange={handleChange} required/>
                        </div>
                    </div>  
                    <div class="middle">
                        <div className="underline"><br/>
                            <Link to="/forgot-password" style={{ color: 'black'}}>Mot de passe oublié</Link>
                        </div>

                        <div className="">
                            <button className="uk-button uk-margin uk-float-right" type="submit">Se connecter {logging ? <div data-uk-spinner="ratio: 0.5"></div> : null}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>                         
    </div>);
}

export default Login;